import { render, staticRenderFns } from "./RDS.vue?vue&type=template&id=7451a54e&"
import script from "./RDS.vue?vue&type=script&lang=js&"
export * from "./RDS.vue?vue&type=script&lang=js&"
import style0 from "./RDS.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports